<!-- resources/js/components/OrderTable.vue -->
<template>
    <div>
      <h1>Pedidos</h1>
      <button class="btn btn-primary" @click="openModal">Crear Pedido</button>
      <table class="table table-striped mt-3">
        <thead>
          <tr>
            <th>ID</th>
            <th>Cliente</th>
            <th>Productos</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in orders" :key="order.id">
            <td>{{ order.id }}</td>
            <td>{{ order.cliente.name }}</td>
            <td>
              <ul>
                <li v-for="product in order.productos" :key="product.id">
                  {{ product.name }} ({{ product.pivot.quantity }}) - ${{ product.pivot.total_price }}
                </li>
              </ul>
            </td>
            <td>${{ order.total_price }}</td>
          </tr>
        </tbody>
      </table>
  
      <!-- Modal -->
      <div class="modal" tabindex="-1" ref="modal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Crear Pedido</h5>
              <button type="button" class="btn-close" @click="closeModal"></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="createOrder">
                <div class="mb-3">
                  <label for="clientId" class="form-label">ID del Cliente</label>
                  <input type="number" class="form-control" id="clientId" v-model="newOrder.clientId" required>
                </div>
                <div class="mb-3">
                  <label for="productId" class="form-label">ID del Producto</label>
                  <input type="number" class="form-control" id="productId" v-model="newOrder.productId" required>
                </div>
                <div class="mb-3">
                  <label for="quantity" class="form-label">Cantidad</label>
                  <input type="number" class="form-control" id="quantity" v-model="newOrder.quantity" required>
                </div>
                <button type="submit" class="btn btn-primary">Crear</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        orders: [],
        newOrder: {
          clientId: '',
          productId: '',
          quantity: ''
        }
      };
    },
    methods: {
      fetchOrders() {
        axios.get('/api/orders')
          .then(response => {
            this.orders = response.data;
          })
          .catch(error => {
            console.error('Error fetching orders:', error);
          });
      },
      openModal() {
        this.$refs.modal.style.display = 'block';
      },
      closeModal() {
        this.$refs.modal.style.display = 'none';
      },
      createOrder() {
        axios.post('/api/orders', {
          client_id: this.newOrder.clientId,
          product_id: this.newOrder.productId,
          quantity: this.newOrder.quantity
        })
        .then(response => {
          console.log('Order created:', response.data);
          this.fetchOrders();
          this.closeModal();
        })
        .catch(error => {
          console.error('Error creating order:', error);
        });
      }
    },
    mounted() {
      this.fetchOrders();
    }
  };
  </script>
  
  <style>
  .modal {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1050;
    padding-top: 60px;
  }
  .modal-dialog {
    margin: auto;
    width: 80%;
    max-width: 600px;
  }
  .modal-content {
    position: relative;
    background-color: #fff;
    border: 1px solid #888;
    border-radius: .3rem;
    box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
    outline: 0;
  }
  </style>